import { JournalChildDTO, JournalChildDatesFormFields } from 'types';
import { parseStringIntoDayjsDate } from '../dateTime/parseStringIntoDayjsDate';

export const parseJournalChildDTOIntoJournalChildDatesFormFields: (
    journalChild: JournalChildDTO,
) => JournalChildDatesFormFields = (journalChild) => ({
    leaveDate: journalChild.leaveDate ? parseStringIntoDayjsDate(journalChild.leaveDate) : null,
    joinDate: parseStringIntoDayjsDate(journalChild.joinDate),
});
